const eventLocation = () => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `header_location_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on location`,
    eventLabel: `geolocation tag`,
  });
};
export default eventLocation;
